import type { CustomContactInput } from "../../../../graphql/types";
import type { UpdateMemberFormState } from "./UpdateMember";
import { hasUnsavedFormChanges } from "../../../common/formStateDirty";

export const getCustomContactErrors = (contact: CustomContactInput) => ({
  name: contact.name.trim() ? "" : "Contact Name is required",
  email: /^\S+@\S+\.\S+$/.test(contact.email.trim()) ? "" : "Enter a valid email address.",
});

export const normalizeCustomContact = (contact: CustomContactInput): CustomContactInput => ({
  ...contact,
  name: contact.name.trim(),
  email: contact.email.trim(),
  jobTitle: contact.jobTitle.trim(),
});

export const getChangedCustomContactErrors = ({
  contacts, baseline, contactId,
}: {
  contacts: CustomContactInput[];
  baseline: CustomContactInput[];
  contactId?: string;
}): Record<string, string> => {
  const errors: Record<string, string> = {};
  for (const contact of contacts) {
    if (contactId ? contact.id !== contactId : !hasUnsavedFormChanges({
      baseline: baseline.find(item => item.id === contact.id), current: contact,
    })) continue;
    if (Object.values(getCustomContactErrors(contact)).some(Boolean)) {
      errors[`custom:${contact.id}`] = "Enter the contact name and a full email address for this Additional Contact.";
    }
  }
  return errors;
};

export const getMemberContactCopySource = (
  state: {
    directory: Pick<UpdateMemberFormState["directory"], "mainCompanyContactName" | "mainCompanyContactEmail" | "mainCompanyPhone" | "mainCompanyPhoneExt">;
    contacts: Pick<UpdateMemberFormState["contacts"], "primaryVoting">;
  },
  role: keyof UpdateMemberFormState["contacts"],
) => role === "primaryVoting"
  ? {
      name: state.directory.mainCompanyContactName,
      email: state.directory.mainCompanyContactEmail,
      companyPhone: state.directory.mainCompanyPhone,
      ext: state.directory.mainCompanyPhoneExt,
    }
  : { ...state.contacts.primaryVoting };
